module.exports = __webpack_public_path__ + "static/media/0325_IMG_LE_SOL_MEGALITH_MEGABLACK.b13896f6.png";